import React from 'react'

import { Context } from './Context'

/**
 */
export const Provider = ({ building, children }) => (
  <Context.Provider value={{ building }}>{children}</Context.Provider>
)
